import {SPropTypeEnum} from "@/components/dto/SPropTypeEnum";
import {SItemTypeEnum} from "@/components/dto/SItemTypeEnum";

export interface STreeItem {
    itemId: string;
    itemType: SItemTypeEnum | undefined,
    parentId: string;
    userViewed: boolean;
    isOpen: boolean;
    isFolder: boolean;
    isFinded: boolean;
    propName: string;
    copyCounter: number;
    propValue: any;
    startTag: string;
    endTag: string;
    propType: SPropTypeEnum | undefined;
    propOutputType: SPropTypeEnum | undefined;
    propOutputValue: any;
    propChildren: STreeItem[];
    propAttributes: SXMLAttributes[];
    toggleCopyPaste: boolean;
    allGenerated: boolean;
    isLastItem: boolean;
    isLastEditItem: boolean;
}

import {v4 as uuid_v4} from "uuid";
import {SXMLAttributes} from "@/components/dto/SXMLTreeItemData";
export class STreeItemImpl{
    static empty():STreeItem{
        return {
            itemId: uuid_v4(),
            itemType: undefined,
            parentId: '',
            userViewed: false,
            isOpen: false,
            isFinded: false,
            isFolder: false,
            propName: 'propertyName',
            copyCounter: 0,
            propValue: 'null',
            startTag: '',
            endTag: '',
            propType: SPropTypeEnum.SNULL,
            propOutputType: SPropTypeEnum.SNULL,
            propOutputValue: '',
            propChildren: [],
            propAttributes: [],
            toggleCopyPaste: false,
            allGenerated: false,
            isLastItem: false,
            isLastEditItem: false
        }
    }
}
